'use strict';

bbw.directive.bbwTopUsersPyramid = function() {
    return {
        scope: {
            'topUsers': '=bbwTopUsersPyramid',
            'linkType': '@linkType'
        },
        templateUrl: bbw.templateUrl('top-users-pyramid.html')
    };
};
